const _g_route = (route) => route, _g_multipleRoutes = (routes) => routes, _g_singleReplacementRoutes = (oldAndNewRoutes) => oldAndNewRoutes, _g_endPoint = ($marker) => {
    const point = $marker.p();
    return {
        op: point,
        ip: point.pp(),
        l: point.il(),
        r: point.r(),
    };
}, _g_startPoint = ($marker) => {
    const point = $marker.p();
    return {
        op: point,
        ip: point.np(),
        l: point.ol(),
        r: point.r(),
    };
}, _g_cornerPoint = ($marker) => {
    const point = $marker.p();
    return {
        cp: point,
        pp: point.pp(),
        np: point.np(),
        il: point.il(),
        ol: point.ol(),
        r: point.r(),
    };
}, _g_pointMove = ($marker, oldLatLng, newLatLng) => {
    const point = $marker.p();
    return {
        p: point,
        op: oldLatLng,
        np: newLatLng,
        r: point.r(),
    };
};
export { _g_route, _g_multipleRoutes, _g_startPoint, _g_endPoint, _g_cornerPoint, _g_pointMove, };
